import React from 'react';
import { useWizardStore } from './useWizardStore';

const STEPS = [
  { num: 1, label: '生成目录' },
  { num: 2, label: '内容撰写' },
  { num: 3, label: '导出' },
];

interface WizardLayoutProps {
  children: React.ReactNode;
}

const WizardLayout: React.FC<WizardLayoutProps> = ({ children }) => {
  const currentStep = useWizardStore((s) => s.currentStep);

  return (
    <div className="max-w-4xl mx-auto">
      {/* Step Indicator */}
      <div className="flex items-center justify-center mb-10">
        {STEPS.map((step, i) => (
          <React.Fragment key={step.num}>
            <div className="flex items-center gap-2.5">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-colors ${
                step.num < currentStep
                  ? 'bg-emerald-500 text-white'
                  : step.num === currentStep
                  ? 'bg-primary text-white'
                  : 'bg-accent text-muted-foreground'
              }`}>
                {step.num < currentStep ? '✓' : step.num}
              </div>
              <span className={`text-sm font-medium ${
                step.num <= currentStep ? 'text-foreground' : 'text-muted-foreground'
              }`}>
                {step.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div className={`w-12 h-0.5 mx-2 rounded ${
                step.num < currentStep ? 'bg-emerald-500' : 'bg-accent'
              }`} />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Step Content */}
      <div className="card p-6">{children}</div>
    </div>
  );
};

export default WizardLayout;
